import { render, staticRenderFns } from "./PromotionTransactionList.vue?vue&type=template&id=d530b8b4&"
import script from "./PromotionTransactionList.vue?vue&type=script&lang=ts&"
export * from "./PromotionTransactionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports